import { snoozed, unsnoozed } from './showNotificationOnSchedule.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import { OwaDate } from 'owa-datetime';
import loc from 'owa-localize';
import { undoAction } from 'owa-locstrings/lib/strings/undoaction.locstring.json';
import { getListViewNotificationDimensions } from 'owa-mail-layout';
import * as undoActions from 'owa-mail-undo';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import { getUserConfiguration } from 'owa-session-store';

/**
 * show notification on schedule
 */
export default function showNotificationOnSchedule(
    allowUndo: boolean,
    scheduleReturnTime?: OwaDate
) {
    if (!getUserConfiguration().UserOptions.ShowNotificationBar) {
        return;
    }

    const notificationText = scheduleReturnTime ? loc(snoozed) : loc(unsnoozed);
    const notificationDimensions = getListViewNotificationDimensions();

    lazyShowNotification.importAndExecute(
        'scheduleNotification',
        'MailModuleNotificationBarHost',
        notificationText,
        {
            icon: ControlIcons.Clock,
            primaryActionText: allowUndo ? loc(undoAction) : null,

            // Want 12 px of padding on either side of the notification bar
            minWidth: notificationDimensions.minWidth,
            maxWidth: notificationDimensions.maxWidth,
            notificationCallback: (reason: NotificationBarCallbackReason) => {
                if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                    undoActions.lazyUndo.importAndExecute('NotificationBar');
                }
            },
        }
    );
}
